module.exports = __webpack_public_path__ + "img/UT0414.7985207c.png";